import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// build-bust 2026-07-12: force a real Vercel rebuild (see ops/src/index.js note — same skipped-build chain risk applies to this project).
